import * as React from 'react';
var defaults = {
    getExposure: function (name) { return null; },
    logExperiment: function (exposure) { return void (0); }
};
/**
 * @protected
 */
export var ExperimentContext = React.createContext(defaults);
export var ExperimentProvider = function (props) { return (React.createElement(ExperimentContext.Provider, { value: props.config || defaults, children: props.children || null })); };
//# sourceMappingURL=experiment-context.js.map